import React from 'react';
import PropTypes from 'prop-types';

const ReportDriversScoreCardRow = ({ item, ...rest }) => {
  let scoreClass = '';

  if (item.driving_score <= 2) {
    scoreClass = 'bg-success text-white';
  } else if (item.driving_score <= 5) {
    scoreClass = 'bg-warning';
  } else {
    scoreClass = 'bg-danger text-white';
  }

  return (
    <tr {...rest}>
      <td>{item.driver_name}</td>
      <td><strong>{item.driven_vehicles}</strong></td>
      <td><strong>{item.orders_count}</strong></td>
      <td>{item.driver_carrier}</td>
      <td className="text-center">
        {item.harsh_braking_incidents_points}
      </td>
      <td className="text-center">
        {item.harsh_acceleration_incidents_points}
      </td>
      <td className="text-center">
        {item.over_speeding_incidents_points}
      </td>
      <td className="text-center">
        {item.exceeding_max_driving_hours_points}
      </td>
      <td className="text-center">
        {item.below_minimum_rest_hours_points}
      </td>
      <td className="text-center">
        {item.driving_distance}
      </td>
      <td className={`text-center ${scoreClass}`}>
        {item.driving_score}
      </td>
    </tr>
  );
};

ReportDriversScoreCardRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ReportDriversScoreCardRow;
